<template>
  <div ref="recaptcha"></div>
</template>

<script>
export default {
  props: {
    sitekey: { type: String, required: true },
  },
  data() {
    return {
      widgetId: null,
    };
  },
  mounted() {
    this.loadEnterpriseRecaptcha();
  },
  methods: {
    loadEnterpriseRecaptcha() {
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        this.renderRecaptcha();
      } else {
        const scriptId = 'recaptcha-enterprise-script';
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script');
          script.id = scriptId;
          script.src = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
          script.async = true;
          script.defer = true;
          script.onload = () => this.renderRecaptcha();
          document.head.appendChild(script);
        }
      }
    },

    renderRecaptcha() {
      window.grecaptcha.enterprise.ready(() => {
        if (this.$refs.recaptcha) {
          this.widgetId = window.grecaptcha.enterprise.render(this.$refs.recaptcha, {
            sitekey: this.sitekey,
            size: 'invisible',
            callback: this.onVerify,
            'expired-callback': this.onExpired,
            'error-callback': this.onError,
          });

        } else {
          console.error('The reCAPTCHA element is not available.');
        }
      });
    },

    execute() {
      if (this.widgetId !== null) {
        window.grecaptcha.enterprise.execute(this.widgetId);
      }
    },

    reset() {
      if (this.widgetId !== null) {
        window.grecaptcha.enterprise.reset(this.widgetId);
      }
    },

    onVerify(token) {
      this.$emit('verify', token);
    },

    onExpired() {
      this.$emit('expired');
    },

    onError() {
      this.$emit('error');
    },
  },
};
</script>
